import { useEffect, useState } from 'react';
import { useSetAuthTokenMutation } from '../../api/serverStream';
import { StreamData } from './types';
import config from '../../config';

export const useAuthProtectedStreamUrl = (
  url: string,
  jobId?: string,
): { data: StreamData[], clear: () => void } => {
  // Creates a short-lived cookie to initiate the stream
  const [setAuthToken] = useSetAuthTokenMutation();
  const [data, setData] = useState<StreamData[]>([]);
  const clear = () => {
    setData([]);
  };
  const pushData = (message: StreamData) => {
    setData((prev) => [...prev, message]);
  };

  useEffect(() => {
    if (!jobId) return;

    let evtSource: EventSource | null = null;

    setAuthToken().then(() => {
      evtSource = new EventSource(`${config.apiUrl}${url}`, { withCredentials: true });

      evtSource.onmessage = (event) => {
        try {
          const parsed: StreamData = JSON.parse(event.data);
          pushData(parsed);
        } catch (error) {
          console.error('Error parsing SSE message', error);
        }
      };

      evtSource.onerror = (err) => {
        console.error('EventSource error:', err);
        if (evtSource) {
          evtSource.close();
        }
      };
    }).catch((error) => {
      console.error('Error setting auth token', error);
    });

    return () => {
      if (evtSource) {
        evtSource.close();
      }
    };
  }, [jobId, setAuthToken, url]);

  return { data, clear };
}
